import { RootState } from 'handlers';

export const getNextStepsState = (state: RootState) => ({
  nextSteps: state.reports.nextSteps,
  isLoading: state.reports.isNextStepsLoading,
  isError: state.reports.isNextStepsError,
});
